<template>
  <span>
    <v-container v-if="isLoggedIn">
      <SettingsHeader />
    </v-container>
    <v-container v-else-if="this.$route.meta.isPublic">
      <PublicHeader />
    </v-container>
  </span>
</template>

<script>
import {mapGetters} from 'vuex';
import PublicHeader from "@/modules/core/components/Header/PublicHeader";
import SettingsHeader from "@/modules/settings/components/Header/SettingsHeader";

export default {
  name: 'SettingsModule',
  components: {
    SettingsHeader,
    PublicHeader
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  }
};
</script>
